import { render, staticRenderFns } from "./MilliData.vue?vue&type=template&id=d98cbfd8&"
import script from "./MilliData.vue?vue&type=script&lang=ts&"
export * from "./MilliData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports